import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface AdminNavProps {
  activeTab?: 'orders' | 'categories' | 'products' | 'add-category' | 'add-product';
}

export default function AdminNav({ activeTab }: AdminNavProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const current = activeTab || (
    location.pathname === '/admin/categories' ? 'categories' :
    location.pathname === '/admin/products' ? 'products' :
    location.pathname === '/admin/add-category' ? 'add-category' :
    location.pathname === '/admin/add-product' ? 'add-product' :
    'orders'
  );

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  return (
    <header className="ad-navbar">
      <div className="ad-nav-container">
        {/* Brand */}
        <div className="ad-brand-group" onClick={() => navigate('/admin')}>
          <div className="ad-brand-logo-wrap">
            <img 
              src={require('../Assets/WebsiteLogo.png')} 
              alt="Jai Bhavani Fireworks" 
              className="ad-brand-logo"
            />
          </div>
          <div className="ad-brand-titles">
            <div className="ad-brand-title">
              જય ભવાની <span>Admin</span>
            </div>
            <div className="ad-brand-subtitle">Fireworks Management Portal</div>
          </div>
          <span className="ad-admin-pill">STAFF</span>
        </div>

        {/* Desktop Navigation Links */}
        <nav className="ad-desktop-nav">
          <button 
            className={`ad-nav-tab ${current === 'orders' ? 'active' : ''}`}
            onClick={() => navigate('/admin')}
          >
            <span>📊</span>
            <span>Orders Dashboard</span>
          </button>

          <button 
            className={`ad-nav-tab ${current === 'categories' ? 'active' : ''}`}
            onClick={() => navigate('/admin/categories')}
          >
            <span>📁</span>
            <span>Categories</span>
          </button>

          <button 
            className={`ad-nav-tab ${current === 'products' ? 'active' : ''}`}
            onClick={() => navigate('/admin/products')}
          >
            <span>🧨</span>
            <span>Products</span>
          </button>
        </nav>

        {/* Right Actions */}
        <div className="ad-right-actions">
          <div className="ad-quick-create-dropdown">
            <button 
              className="ad-btn-create"
              onClick={() => navigate('/admin/add-product')}
              title="Add a new fireworks product"
            >
              <span>+ Add Product</span>
            </button>
            <button 
              className="ad-btn-create-sub"
              onClick={() => navigate('/admin/add-category')}
              title="Add a new category"
            >
              <span>+ Category</span>
            </button>
          </div>

          <button 
            className="ad-btn-logout" 
            onClick={handleLogout}
            title="Sign out of admin session"
          >
            Sign Out
          </button>

          {/* Mobile Menu Toggle Button */}
          <button 
            className="ad-mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>

      {/* Mobile Drawer Menu */}
      {mobileMenuOpen && (
        <div className="ad-mobile-drawer">
          <button 
            className={`ad-mobile-drawer-link ${current === 'orders' ? 'active' : ''}`}
            onClick={() => { setMobileMenuOpen(false); navigate('/admin'); }}
          >
            <span>📊</span>
            <span>Orders Dashboard</span>
          </button>
          <button 
            className={`ad-mobile-drawer-link ${current === 'categories' ? 'active' : ''}`}
            onClick={() => { setMobileMenuOpen(false); navigate('/admin/categories'); }}
          >
            <span>📁</span>
            <span>Categories</span>
          </button>
          <button 
            className={`ad-mobile-drawer-link ${current === 'products' ? 'active' : ''}`}
            onClick={() => { setMobileMenuOpen(false); navigate('/admin/products'); }}
          >
            <span>🧨</span>
            <span>Products</span>
          </button>
          <div className="ad-mobile-drawer-divider"></div>
          <button 
            className="ad-mobile-drawer-link"
            onClick={() => { setMobileMenuOpen(false); navigate('/admin/add-product'); }}
          >
            <span>➕</span>
            <span>Add New Product</span>
          </button>
          <button 
            className="ad-mobile-drawer-link"
            onClick={() => { setMobileMenuOpen(false); navigate('/admin/add-category'); }}
          >
            <span>➕</span>
            <span>Add New Category</span>
          </button>
          <button 
            className="ad-mobile-drawer-link logout"
            onClick={handleLogout}
          >
            <span>🚪</span>
            <span>Sign Out</span>
          </button>
        </div>
      )}
    </header>
  );
}
